<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-2">
          <base-input>
            <el-select
              class="select-primary"
              size="large"
              placeholder="Choose contractor"
              v-model="selects.simple_contractor"
              @change="
                getPerformanceOverview();
                getPerformanceGraph();
              "
            >
              <el-option
                v-for="option in selects.contractors"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-lg-4">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="
              getPerformanceOverview();
              getPerformanceGraph();
            "
          ></el-date-picker>
        </div>
        <!-- <div class="col-lg text-right">
          <base-button class="btn-success text-default">
            Export to CSV
          </base-button>
        </div> -->
      </div>
      <div class="row">
        <div class="col-lg-4 d-flex">
          <card type="card-chart-pie">
            <h4>Total Work Orders</h4>
            <h3 class="card-title">
              <div class="chart-area">
                <pie-chart
                  v-if="pieChart2.loaded"
                  :chart-data="pieChart2.chartData"
                  :extra-options="pieChart2.extraOptions"
                  :height="320"
                ></pie-chart>
              </div>
            </h3>
          </card>
        </div>
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg d-flex">
              <card type="card">
                <div class="row">
                  <div class="col-lg">
                    <h4>Open Work Orders</h4>
                  </div>
                  <div class="col-lg text-right">
                    <img
                      src="@/assets/img/Open ticket icon.png"
                      :width="imagewidth"
                    />
                  </div>
                </div>
                <h1 class="card-title text-center">{{ openWO }}</h1>
              </card>
            </div>
            <div class="col-lg d-flex">
              <card type="card">
                <div class="row">
                  <div class="col-lg">
                    <h4>Overdue Work Orders</h4>
                  </div>
                  <div class="col-lg text-right">
                    <img
                      src="@/assets/img/Overdue ticket.png"
                      :width="imagewidth"
                    />
                  </div>
                </div>
                <h1 class="card-title text-center">{{ overdueWO }}</h1>
              </card>
            </div>
            <div class="col-lg d-flex">
              <card type="card">
                <div class="row">
                  <div class="col-lg">
                    <h4>Closed Work Orders</h4>
                  </div>
                  <div class="col-lg text-right">
                    <img
                      src="@/assets/img/Closed ticket.png"
                      :width="imagewidth"
                    />
                  </div>
                </div>
                <h1 class="card-title text-center">{{ closedWO }}</h1>
              </card>
            </div>
            <div class="col-lg d-flex">
              <card type="card">
                <div class="row">
                  <div class="col-lg">
                    <h4>New Work Orders</h4>
                  </div>
                  <div class="col-lg text-right">
                    <img
                      src="@/assets/img/Open ticket.png"
                      :width="imagewidth"
                    />
                  </div>
                </div>
                <h1 class="card-title text-center">{{ newWO }}</h1>
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 d-flex">
              <card type="card">
                <div class="row">
                  <div class="col-lg-12 text-center">
                    <h4>Average Resolved Work Orders</h4>
                  </div>
                  <h3 class="card-title">
                    <div class="chart-area">
                      <pie-chart
                        v-if="pieChart.loaded"
                        :chart-data="pieChart.chartData"
                        :extra-options="pieChart.extraOptions"
                        :height="151"
                      ></pie-chart>
                    </div>
                  </h3>
                </div>
              </card>
            </div>
            <div class="col-lg-3 d-flex">
              <card type="card">
                <div class="row">
                  <div class="col-lg">
                    <h4>Top 5 Faults</h4>
                  </div>
                </div>
                <div v-for="item in faults" :key="item.id">
                  <h5 class="card-title text-left">
                    {{ item.id }}. {{ item.fault }}
                  </h5>
                </div>
              </card>
            </div>
            <div class="col-lg-3 d-flex">
              <card type="card">
                <div class="row">
                  <div class="col-lg">
                    <h4>Top Faulty Parts</h4>
                  </div>
                </div>
                <div v-for="item in faultyPart" :key="item.id">
                  <h5 class="card-title text-left">
                    {{ item.id }}. {{ item.part }}
                  </h5>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg">
          <card type="card-chart-pie">
            <h4 class="text-center">
              {{
                selects.simple_interval[0].toUpperCase() +
                selects.simple_interval.slice(1) +
                "ly"
              }}
              Total Work Orders vs Resolved Work Orders
            </h4>
            <h4 class="text-right">
              <!-- <base-button class="btn-icon">
                <img src="@/assets/img/calender icon.png" width="40px" />
              </base-button> -->
              <el-select
                class="select-primary"
                size="large"
                placeholder="Interval"
                v-model="selects.simple_interval"
                @change="getPerformanceGraph()"
              >
                <el-option
                  v-for="option in selects.intervals"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                >
                </el-option>
              </el-select>
            </h4>
            <h3 class="card-title">
              <div class="chart-area">
                <bar-chart
                  v-if="barChart.loaded"
                  :chart-data="barChart.chartData"
                  :extra-options="barChart.extraOptions"
                  :height="320"
                ></bar-chart>
              </div>
            </h3>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import PieChart from "src/components/Charts/PieChart";
import * as chartConfigs from "@/components/Charts/config";
import swal from "sweetalert2";
import config from "@/config";
import moment from "moment";
import BaseAlert from "../../components/BaseAlert.vue";
import { Select, Option, DatePicker } from "element-ui";

export default {
  components: {
    LineChart,
    BarChart,
    PieChart,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      openWO: 0,
      overdueWO: 0,
      closedWO: 0,
      newWO: 0,
      dateRange: [],
      datefault: "",
      contractor: "",
      selects: {
        contractors: [
          {
            label: "All",
            value: "All",
          },
        ],
        simple_contractor: "",
        intervals: [
          {
            label: "Monthly",
            value: "month",
          },
          {
            label: "Yearly",
            value: "year",
          },
          {
            label: "Quarterly",
            value: "quarter",
          },
        ],
        simple_interval: "",
      },
      imagewidth: "60%",
      pieChart2: {
        chartData: {
          labels: ["Whatsapp", "Email", "Calls", "SISPAA"],
          datasets: [
            {
              label: "Dimm percent",
              pointRadius: 0,
              backgroundColor: ["#b129a5", "#919191", "#ffffff", "#19adc9"],
              pointHoverRadius: 0,
              borderWidth: 0,
              data: [10, 10, 10, 70],
            },
          ],
        },
        loaded: true,
        extraOptions: {
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: "bottom",
            labels: {
              fontColor: "#ffffff",
              usePointStyle: true,
              boxWidth: 10,
            },
          },
          cutoutPercentage: 80,
          tooltips: {
            enabled: false,
          },
          hover: {
            mode: false,
          },
          animation: {
            duration: 500,
            // onProgress: function (animation) {
            //   var chartContext = this.chart.canvas.getContext("2d", {
            //     alpha: false,
            //   });
            //   chartContext.fillStyle = "#ffffff";
            //   chartContext.font = "100 36px Rubik";
            //   chartContext.textBaseline = "middle";
            //   let arr = this.data.datasets[0].data
            //   let suma = arr.reduce((a,b) => a + b, 0)

            //   chartContext.fillText(
            //     suma + " Tickets",
            //     this.chart.width / 2 - 80,
            //     this.chart.height / 2,
            //     200
            //   );
            // },
            onComplete: function (animation) {
              var chartContext = this.chart.canvas.getContext("2d", {
                alpha: false,
              });
              chartContext.fillStyle = "#ffffff";
              chartContext.font = "100 30px sans-serif";
              chartContext.textBaseline = "middle";
              let arr = this.data.datasets[0].data;
              let suma = arr.reduce((a, b) => a + b, 0);

              chartContext.fillText(
                suma + " Work Orders",
                this.chart.width / 2 - 90,
                this.chart.height / 2.2,
                200
              );
            },
          },
        },
      },
      pieChart: {
        chartData: {
          labels: ["1-3 Days", "4-7 Days", "More Than 7 Days"],
          datasets: [
            {
              label: "Dimm percent",
              pointRadius: 0,
              backgroundColor: ["#19adc9", "#b129a5", "#919191"],
              pointHoverRadius: 0,
              borderWidth: 0,
              data: [70, 10, 10],
            },
          ],
        },
        loaded: true,
        extraOptions: {
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: "right",
            labels: {
              fontColor: "#ffffff",
              usePointStyle: true,
              boxWidth: 10,
            },
          },
          cutoutPercentage: 80,
          tooltips: {
            enabled: false,
          },
          hover: {
            mode: false,
          },
          animation: {
            duration: 500,
            // onProgress: function (animation) {
            //   var chartContext = this.chart.canvas.getContext("2d", {
            //     alpha: false,
            //   });
            //   chartContext.fillStyle = "#ffffff";
            //   chartContext.font = "100 36px Rubik";
            //   chartContext.textBaseline = "middle";
            //   let arr = this.data.datasets[0].data
            //   let suma = arr.reduce((a,b) => a + b, 0)

            //   chartContext.fillText(
            //     suma + " Tickets",
            //     this.chart.width / 2 - 80,
            //     this.chart.height / 2,
            //     200
            //   );
            // },
            // onComplete: function (animation) {
            //   var chartContext = this.chart.canvas.getContext("2d", {
            //     alpha: false,
            //   });
            //   chartContext.fillStyle = "#ffffff";
            //   chartContext.font = "100 24px sans-serif";
            //   chartContext.textBaseline = "middle";
            //   let arr = this.data.datasets[0].data[0];
            //   let display = arr + " day(s)";
            //   var lines = display.split("\n");
            //   // console.log(lines);
            //   // console.log(display);

            //   chartContext.fillText(
            //     lines,
            //     this.chart.width / 2 - 130,
            //     this.chart.height / 2,
            //     200
            //   );
            // },
          },
        },
      },
      barChart: {
        chartData: {
          labels: [
            "Jan",
            "Feb",
            "Mac",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
          ],
          datasets: [
            {
              label: "New Work Orders",
              fill: true,
              borderColor: "#ffffff00",
              backgroundColor: config.colors.white,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 100, 70, 80, 120, 80, 80, 120, 80],
            },
            {
              label: "Closed Work Orders",
              fill: true,
              borderColor: "#ffffff00",
              backgroundColor: "#bb48b0",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 100, 70, 80, 120, 80, 80, 100, 70],
            },
            {
              label: "Overdue Work Orders",
              fill: true,
              borderColor: "#ffffff00",
              backgroundColor: "#36b8d2",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 100, 70, 80, 120, 80, 100, 70, 80],
            },
          ],
        },
        extraOptions: {
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: "top",
            labels: {
              fontColor: "#ffffff",
              usePointStyle: true,
              boxWidth: 10,
            },
          },
          scales: {
            yAxes: [
              {
                // gridLines: {
                //   drawBorder: false,
                //   color: "rgba(253,93,147,0.1)",
                //   zeroLineColor: "transparent",
                // },
                ticks: {
                  suggestedMin: 60,
                  suggestedMax: 125,
                  padding: 20,
                  fontColor: "#ffffff",
                },
              },
            ],

            xAxes: [
              {
                // gridLines: {
                //   drawBorder: false,
                //   color: "rgba(253,93,147,0.1)",
                //   zeroLineColor: "transparent",
                // },
                ticks: {
                  padding: 20,
                  fontColor: "#ffffff",
                },
              },
            ],
          },
        },
        loaded: true,
        gradientColors: config.colors.pinkGradient,
        gradientStops: [0.5, 0.2, 0.4],
      },
      faults: [
        {
          id: 1,
          fault: "Flickering",
        },
        {
          id: 2,
          fault: "Overvoltage",
        },
        {
          id: 3,
          fault: "Undervoltage",
        },
        {
          id: 4,
          fault: "Gateway Issue",
        },
        {
          id: 5,
          fault: "Driver Issue",
        },
      ],
      faultyPart: [
        {
          id: 1,
          part: "SPD",
        },
        {
          id: 2,
          part: "LED",
        },
        {
          id: 3,
          part: "Wire/cables",
        },
        {
          id: 4,
          part: "Gateway",
        },
        {
          id: 5,
          part: "Node",
        },
      ],
    };
  },
  computed: {},
  methods: {
    // textCenter(val) {
    //   Chart.pluginService.register({
    //     beforeDraw: function (chart) {
    //       var width = chart.chart.width,
    //         height = chart.chart.height,
    //         ctx = chart.chart.ctx;
    //       ctx.restore();
    //       var fontSize = (height / 114).toFixed(2);
    //       ctx.font = fontSize + "em sans-serif";
    //       ctx.textBaseline = "middle";
    //       var text = val,
    //         textX = Math.round((width - ctx.measureText(text).width) / 2),
    //         textY = height / 2;
    //       ctx.fillText(text, textX, textY);
    //       ctx.save();
    //     },
    //   });
    // },
    myEventHandler(e) {
      // console.log("Check Screen Size");
      // console.log(e);
      this.imagewidth = "60px";
    },
    // ################# DZAF ################# //
    getContractor() {
      this.$http.get(`:8002/api/v1/contractor`).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          this.selects.contractors = [
            {
              label: "All",
              value: "All",
            },
          ];

          for (let i = 0; i < response.length; i++) {
            let contractor = {
              value: response[i].ContractorID,
              label: response[i].ContractorName,
            };
            this.selects.contractors.push(contractor);
          }
          console.log(this.selects.contractors);
        }
      });
    },
    getPerformanceOverview() {
      let contractorID;
      let start = moment(this.dateRange[0]).unix();
      let end = moment(this.dateRange[1]).unix();
      contractorID = this.selects.simple_contractor;

      console.log(start, end);
      console.log(contractorID);
      this.pieChart2.loaded = false;
      this.pieChart.loaded = false;
      this.$http
        .get(
          `:8002/api/v1/work-order/performance/overview/${contractorID}/${start}/${end}`
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            // TOTAL WORK ORDERS BY SOURCE
            let workOrderSource = response.WorkOrderSource;
            let pieChart2Label = [];
            let pieChart2Data = [];
            for (let i = 0; i < workOrderSource.length; i++) {
              pieChart2Label.push(workOrderSource[i].SourceName);
              pieChart2Data.push(workOrderSource[i].Count);
            }
            this.pieChart2.chartData.labels = pieChart2Label;
            this.pieChart2.chartData.datasets[0].data = pieChart2Data;

            // WORK ORDERS STATUS COUNT
            this.newWO = 0;
            this.openWO = 0;
            this.closedWO = 0;
            this.overdueWO = 0;
            let statusCount = response.StatusCount;
            for (let i = 0; i < statusCount.length; i++) {
              if (statusCount[i].WoStatusID == 1) {
                this.newWO = statusCount[i].Count;
              } else if (statusCount[i].WoStatusID == 2) {
                this.openWO = statusCount[i].Count;
              } else if (statusCount[i].WoStatusID == 4) {
                this.closedWO = statusCount[i].Count;
              } else if (statusCount[i].WoStatusID == 6) {
                this.overdueWO = statusCount[i].Count;
              }
            }

            // AVG RESOLVED WORK ORDERS
            let avgResoveWO = response.AvgResolveWO;
            let pieChartData = [];
            pieChartData.push(avgResoveWO.LessThree);
            pieChartData.push(avgResoveWO.BetweenFourSeven);
            pieChartData.push(avgResoveWO.MoreSeven);

            this.pieChart.chartData.datasets[0].data = pieChartData;
            this.pieChart.extraOptions = {
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: "right",
                labels: {
                  fontColor: "#ffffff",
                  usePointStyle: true,
                  boxWidth: 10,
                },
              },
              cutoutPercentage: 80,
              tooltips: {
                enabled: false,
              },
              hover: {
                mode: false,
              },
              // animation: {
              //   duration: 500,
              //   onComplete: function (animation) {
              //     var chartContext = this.chart.canvas.getContext("2d", {
              //       alpha: false,
              //     });
              //     chartContext.fillStyle = "#ffffff";
              //     chartContext.font = "100 24px sans-serif";
              //     chartContext.textBaseline = "middle";
              //     let arr = this.data.datasets[0].data[0];
              //     let display = avgResoveWO.AvgDays;
              //     var lines = display.split("\n");
              //     console.log(avgResoveWO.AvgDays);
              //     // console.log(display);

              //     chartContext.fillText(
              //       lines,
              //       this.chart.width / 2 - 130,
              //       this.chart.height / 2,
              //       200
              //     );
              //   },
              // },
            };

            // TOP FAULT TYPE
            this.faults = [];
            let topFaultType = response.TopFaultType;

            for (let i = 0; i < topFaultType.length; i++) {
              let obj = {
                id: i + 1,
                fault: topFaultType[i].FaultName,
              };
              this.faults.push(obj);
            }

            // TOP FAULT PARTS
            this.faultyPart = [];
            let topFaultyParts = response.TopFaultyParts;

            for (let i = 0; i < topFaultyParts.length; i++) {
              let obj = {
                id: i + 1,
                part: topFaultyParts[i].PartsName,
              };
              this.faultyPart.push(obj);
            }

            this.pieChart2.loaded = true;
            this.pieChart.loaded = true;
          }
        });
    },
    getPerformanceGraph() {
      let contractorID = this.selects.simple_contractor;
      let interval = this.selects.simple_interval;

      this.barChart.loaded = false;
      this.$http
        .get(
          `:8002/api/v1/work-order/performance/graph/${contractorID}/${interval}`
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.barChart.chartData.labels = response.Timestamp;
            this.barChart.chartData.datasets[0].data = response.NewCount;
            this.barChart.chartData.datasets[1].data = response.ClosedCount;
            this.barChart.chartData.datasets[2].data = response.OverdueCount;
            console.log(response);
            this.barChart.loaded = true;
          }
        });
    },
  },
  mounted() {
    // let data = 110 + " Tickets";
    // this.textCenter(data);
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
    this.selects.simple_contractor = this.selects.contractors[0].value;
    this.selects.simple_interval = this.selects.intervals[0].value;
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    var firstDay = new Date(y, m, 1);
    var lastDay = new Date(y, m + 1, 0);
    this.dateRange.push(firstDay, lastDay);
    this.getContractor();
    this.getPerformanceOverview();
    this.getPerformanceGraph();
  },
};
</script>
<style scoped>
</style>
